<template>
<div class="connector">
  <div  class="node" :style="'left:'+pt1.x+'px;top:'+pt1.y+'px;'"></div>
  <div  class="node" :style="'left:'+pt2.x+'px;top:'+pt2.y+'px;'"></div>
  <div  :class="'conline '+cl1.br" :style="'left:'+cl1.x+'px;top:'+cl1.y+'px;width:'+cl1.w+'px;height:'+cl1.h+'px;'"></div>
  <div  :class="'conline '+cl2.bl" :style="'left:'+cl2.x+'px;top:'+cl2.y+'px;width:'+cl2.w+'px;height:'+cl2.h+'px;'"></div>
  </div>
</template>

<script>
export default {
  props: {
    
    pt1:{type: Object,default: function () { return {x:0,y:120} }},
    pt2:null,

  },
  data() {
    return {
      nodeSize:4,
     
    };
  },
  computed: {
    leftPt(){
      if(this.pt1.x>this.pt2.x){
        return this.pt2
      }else{
        return this.pt1
      }
    },
    rightPt(){
      if(this.pt1.x>this.pt2.x){
        return this.pt1
      }else{
        return this.pt2
      }
    },
    cl1(){
      let br="BB"
      
      if(this.leftPt.y < this.rightPt.y ){
        br="BR"
      }
      
      return { x:this.leftPt.x+this.nodeSize*2,
               y:Math.min(this.pt1.y,this.pt2.y)+this.nodeSize,
               w:Math.abs(this.pt1.x - this.pt2.x)*.5-this.nodeSize,
               h:Math.abs(this.pt1.y - this.pt2.y),
               br:br
             }
    },
    cl2(){
      let bl="BB"
      if(this.leftPt.y > this.rightPt.y ){
        bl="BL"
      }
      let w=Math.abs(this.pt1.x - this.pt2.x)*.5-this.nodeSize
      return { x:this.leftPt.x+w+this.nodeSize*2,
               y:Math.min(this.pt1.y,this.pt2.y)+this.nodeSize,
               w:w,
               h:Math.abs(this.pt1.y - this.pt2.y),
               bl:bl
             }
    }
     
  },
  methods: {
    
  },
};
</script>

<style lang="scss" scoped>
 @import "@/assets/sass/variables.scss";
//$border-blue:#00bbff;
.connector{
  position:absolute;
  left:0px;
  top:0px;
}
.node {
  position:absolute;
  width: 6px;
  height:6px;
  border: solid 3px $glow-colour;
  border-radius:50%!important
}
.conline{
  pointer-events: none;
  position:absolute;
  position:absolute;
  border-top: solid 3px $glow-colour;
}
.conline.BB{
  border-top: none;
  border-bottom: solid 3px $glow-colour;
}
.conline.BR{
  border-right: solid 3px $glow-colour;
}
.conline.BL{
  border-left: solid 3px $glow-colour;
}

</style>
